import React from 'react'

const ArrowUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99998 6.98965L16.5407 13.5304L17.6014 12.4697L9.99998 4.86833L2.39858 12.4697L3.45924 13.5304L9.99998 6.98965Z" fill="#6B7073"/>
  </svg>
)

export default ArrowUp